import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Row,
  Col,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { INDIAN_STATES } from "../../Constants/Const";

const AddSupplierModal = ({ isOpen, toggle, onSubmit }) => {
  const validation = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobileNo: "",
      mobileSecNo: "",
      state: "",
      address: "",
      km: "",
      perTripRate: "",
      partyType: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Supplier name is required"),
      email: Yup.string().email("Invalid email address"),
      mobileNo: Yup.string()

        .matches(
          /^[6-9]\d{9}$/,
          "Mobile number must be a valid 10-digit Indian number",
        ),

      mobileSecNo: Yup.string()
        .matches(/^[0-9]{10}$/, "Secondary mobile number must be 10 digits")
        .nullable(),
      address: Yup.string().required("Address is required"),
      // km: Yup.number()
      //   .typeError("KM must be a number")
      //   .min(0, "Cannot be negative")
      //   .required("KM is required"),
      // perTripRate: Yup.number()
      //   .typeError("Per trip rate must be a number")
      //   .min(0, "Cannot be negative")
      //   .required("Per trip rate is required"),

      km: Yup.number().when("partyType", {
        is: "OUTSTATION",
        then: (schema) =>
          schema
            .typeError("KM must be a number")
            .min(0)
            .required("KM is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      perTripRate: Yup.number().when("partyType", {
        is: "LOCAL",
        then: (schema) =>
          schema
            .typeError("Per trip rate must be a number")
            .min(0)
            .required("Per trip rate is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      partyType: Yup.string().required("Party type is required"),
    }),
    // onSubmit: (values) => {
    //   onSubmit(values);
    //   toggle();
    //   validation.resetForm();
    // },

    // onSubmit: (values) => {
    //   const cleanedValues = Object.fromEntries(
    //     Object.entries(values).filter(([_, value]) => {
    //       return value !== "" && value !== null && value !== undefined;
    //     }),
    //   );

    //   if (cleanedValues.km) cleanedValues.km = Number(cleanedValues.km);
    //   if (cleanedValues.perTripRate)
    //     cleanedValues.perTripRate = Number(cleanedValues.perTripRate);

    //   if (onSubmit) onSubmit(cleanedValues);

    //   toggle();
    //   validation.resetForm();
    // },

    onSubmit: (values) => {
      // Create a copy so we don't mutate Formik's values directly
      const payload = { ...values };

      // Set the hidden field to 0
      if (payload.partyType === "OUTSTATION") {
        payload.perTripRate = 0;
      }

      if (payload.partyType === "LOCAL") {
        payload.km = 0;
      }

      const cleanedValues = Object.fromEntries(
        Object.entries(payload).filter(([_, value]) => {
          return value !== "" && value !== null && value !== undefined;
        }),
      );

      cleanedValues.km = Number(cleanedValues.km);
      cleanedValues.perTripRate = Number(cleanedValues.perTripRate);

      if (onSubmit) onSubmit(cleanedValues);

      toggle();
      validation.resetForm();
    },
  });

  const preventNumberChange = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const preventWheelChange = (e) => {
    e.currentTarget.blur();
  };

  useEffect(() => {
    if (!isOpen) validation.resetForm();
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered fade>
      <ModalHeader toggle={toggle} className="bg-light">
        Add Supplier
      </ModalHeader>

      <Form onSubmit={validation.handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Name <span className="text-danger">*</span>
                </Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter supplier name"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name}
                  invalid={validation.touched.name && !!validation.errors.name}
                />
                <FormFeedback>{validation.errors.name}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email}
                  invalid={
                    validation.touched.email && !!validation.errors.email
                  }
                />
                <FormFeedback>{validation.errors.email}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Mobile No</Label>
                <Input
                  id="mobileNo"
                  name="mobileNo"
                  type="text"
                  placeholder="Enter primary mobile no"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.mobileNo}
                  invalid={
                    validation.touched.mobileNo && !!validation.errors.mobileNo
                  }
                />
                <FormFeedback>{validation.errors.mobileNo}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Secondary Mobile No</Label>
                <Input
                  id="mobileSecNo"
                  name="mobileSecNo"
                  type="text"
                  placeholder="Enter secondary mobile no"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.mobileSecNo}
                  invalid={
                    validation.touched.mobileSecNo &&
                    !!validation.errors.mobileSecNo
                  }
                />
                <FormFeedback>{validation.errors.mobileSecNo}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              {/* <FormGroup>
                <Label>
                  State <span className="text-danger">*</span>
                </Label>
                <Input
                  id="state"
                  name="state"
                  type="text"
                  placeholder="Enter state"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.state}
                  invalid={
                    validation.touched.state && !!validation.errors.state
                  }
                />
                <FormFeedback>{validation.errors.state}</FormFeedback>
              </FormGroup> */}
              <FormGroup>
                <Label>State</Label>

                <Select
                  id="state"
                  name="state"
                  options={INDIAN_STATES}
                  placeholder="Select State"
                  value={INDIAN_STATES.find(
                    (item) => item.value === validation.values.state,
                  )}
                  onChange={(selectedOption) => {
                    validation.setFieldValue("state", selectedOption.value);
                  }}
                  onBlur={() => validation.setFieldTouched("state", true)}
                  classNamePrefix="react-select"
                />

                {validation.touched.state && validation.errors.state && (
                  <div className="text-danger small">
                    {validation.errors.state}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>
                  Address <span className="text-danger">*</span>
                </Label>
                <Input
                  id="address"
                  name="address"
                  type="text"
                  placeholder="Enter address"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.address}
                  invalid={
                    validation.touched.address && !!validation.errors.address
                  }
                />
                <FormFeedback>{validation.errors.address}</FormFeedback>
              </FormGroup>
            </Col>

            {/* <Col md={6}>
              <FormGroup>
                <Label>
                  Per KM Rate <span className="text-danger">*</span>
                </Label>
                <Input
                  id="km"
                  name="km"
                  type="number"
                  placeholder="Enter distance in KM"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.km}
                  invalid={validation.touched.km && !!validation.errors.km}
                />
                <FormFeedback>{validation.errors.km}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>
                  Per Trip Rate <span className="text-danger">*</span>
                </Label>
                <Input
                  id="perTripRate"
                  name="perTripRate"
                  type="number"
                  placeholder="Enter per trip rate"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.perTripRate}
                  invalid={
                    validation.touched.perTripRate &&
                    !!validation.errors.perTripRate
                  }
                />
                <FormFeedback>{validation.errors.perTripRate}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <Label>
                  Party Type <span className="text-danger">*</span>
                </Label>
                <Input
                  id="partyType"
                  name="partyType"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.partyType}
                  invalid={
                    validation.touched.partyType &&
                    !!validation.errors.partyType
                  }
                >
                  <option value="">Select Party Type</option>
                  <option value="LOCAL">Local</option>
                  <option value="OUTSTATION">Outstation</option>
                </Input>

                <FormFeedback>{validation.errors.partyType}</FormFeedback>
              </FormGroup>
            </Col> */}
            <Col md={6}>
              <FormGroup>
                <Label>
                  Party Type <span className="text-danger">*</span>
                </Label>
                <Input
                  id="partyType"
                  name="partyType"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.partyType}
                  invalid={
                    validation.touched.partyType &&
                    !!validation.errors.partyType
                  }
                >
                  <option value="">Select Party Type</option>
                  <option value="LOCAL">Local</option>
                  <option value="OUTSTATION">Outstation</option>
                </Input>

                <FormFeedback>{validation.errors.partyType}</FormFeedback>
              </FormGroup>
            </Col>

            {validation.values.partyType === "OUTSTATION" && (
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Per KM <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="km"
                    name="km"
                    type="number"
                    placeholder="Enter per KM"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    onKeyDown={preventNumberChange}
                    onWheel={preventWheelChange}
                    value={validation.values.km}
                    invalid={validation.touched.km && !!validation.errors.km}
                  />
                  <FormFeedback>{validation.errors.km}</FormFeedback>
                </FormGroup>
              </Col>
            )}

            {validation.values.partyType === "LOCAL" && (
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Per Trip <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="perTripRate"
                    name="perTripRate"
                    type="number"
                    placeholder="Enter per trip "
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    onKeyDown={preventNumberChange}
                    onWheel={preventWheelChange}
                    value={validation.values.perTripRate}
                    invalid={
                      validation.touched.perTripRate &&
                      !!validation.errors.perTripRate
                    }
                  />
                  <FormFeedback>{validation.errors.perTripRate}</FormFeedback>
                </FormGroup>
              </Col>
            )}
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" className="btn-sm" onClick={toggle}>
            Cancel
          </Button>
          <Button color="success" className="btn-sm" type="submit">
            Add Supplier
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddSupplierModal;
